import { useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { useReauthenticate } from "../../../components/security/useReauthenticate";
import { signInAgain } from "../../../utils/mfa-step-up";
import { MfaChallenge } from "../../pages/auth/MfaChallenge";
import { Notice } from "../../pages/auth/parts";
import { Button } from "@/v2/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/v2/ui/dialog";

/** Changing how you sign in needs a recent sign-in; this asks for one without leaving the page */
export function ReauthenticateDialog({ open, onSuccess, onCancel }: { open: boolean; onSuccess: () => void; onCancel: () => void }) {
    const location = useLocation();
    const { error, loading, challenge, federated, hasPasskey, handleResult, abandon } = useReauthenticate({ open, onSuccess });

    return (
        <Dialog open={open} onOpenChange={next => !next && onCancel()}>
            <DialogContent data-v2="" className="sm:max-w-sm">
                <DialogHeader>
                    <DialogTitle className="font-display text-lg font-semibold">Confirm it's you</DialogTitle>
                    <DialogDescription>It's been a while since you signed in. Confirm it's you before changing how you sign in.</DialogDescription>
                </DialogHeader>
                {federated ? (
                    <Button size="lg" className="w-full" onClick={() => signInAgain(location.pathname)}>Sign in again with Google or GitHub</Button>
                ) : challenge ? (
                    <MfaChallenge
                        key={challenge.transactionId}
                        challenge={challenge}
                        onResult={handleResult}
                        onCancel={onCancel}
                        onAbandon={abandon}
                        preferPasskey={hasPasskey}
                        cancelLabel="Cancel"
                    />
                ) : loading ? (
                    <div className="grid place-items-center py-6 text-text-3"><Loader2 className="size-5 animate-spin" /></div>
                ) : error ? (
                    <div>
                        <Notice title={error} />
                        <Button variant="outline" size="lg" className="w-full" onClick={onCancel}>Close</Button>
                    </div>
                ) : null}
            </DialogContent>
        </Dialog>
    );
}
